import { LiveAnnouncer } from '@angular/cdk/a11y';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AppMasterService } from 'app/business/service/app/app-master.service';
import xmlFormat from 'xml-formatter';


@Component({
  selector: 'app-nsw-tracking-response-modal',
  templateUrl: './nsw-tracking-response-modal.component.html',
  styleUrls: ['./nsw-tracking-response-modal.component.css']
})
export class NswTrackingResponseModalComponent implements OnInit {
  dataSource = new MatTableDataSource<any>();
  displayedColumns: string[] = [
    "index",
    "responseTime",
    "responseAction",
    "action",
  ];
  clickBody: boolean = false;
  form: any = {};
  datas: any = {};

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _liveAnnouncer: LiveAnnouncer,
    private dialog: MatDialog,
    private appMasterService: AppMasterService,
  ) {
    console.log(data);
    this.datas = data;
  }

  ngOnInit() {
    this.loadData();
  }

  ngAfterViewInit() {
    this.paginator.pageIndex = 0;
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce("Sorting cleared");
    }
  }

  loadData() {
    var request = {
      id: this.datas.id
    };

    this.appMasterService.getNswTrackingResponseList(request).then((res: any) => {
      if (res === 'error') {
        return;
      } else {
        if (res === null) {
          return;
        } else {
          this.dataSource = new MatTableDataSource(res);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }
      }
    })
  }

  openInfo(e) {
    if (this.isJsonString(e.responseBody)) {
      var responseBodyObj = JSON.parse(e.responseBody);
      var responseBodyStr = JSON.stringify(responseBodyObj, null, 4);

      this.form.responseBody = responseBodyStr;
    } else {
      try
      {
        var formatXml = xmlFormat(e.responseBody);
        this.form.responseBody = formatXml;
      }
      catch (err) 
      {
        this.form.responseBody = e.responseBody;
      }
    }

    this.clickBody = true;
  }

  isJsonString(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }
}
